// CategoryIdLayout.jsx
import React from 'react';
import { Outlet } from 'react-router';

import UniversalContainer from '../component/UniversalContainer.jsx';

const CategoryIdLayout = () => {
  return (
    <>
      <UniversalContainer filename="MessageCategoryFeedsById">
        <Outlet />
      </UniversalContainer>
    </>
  );
};

export default CategoryIdLayout;
